import { VideoPlayerEndedSegmentEvent } from '@/modules/core/app/models/segmentevents/VideoPlayerEndedSegmentEvent';
import { VideoPlayerSegmentWatchedSegmentEvent } from '@/modules/core/app/models/segmentevents/VideoPlayerSegmentWatchedSegmentEvent';
import { VideoPlayerStartedSegmentEvent } from '@/modules/core/app/models/segmentevents/VideoPlayerStartedSegmentEvent';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';

export class VideoPlayerTrackingService extends BaseService {
  watchedSegments: Set<number> = new Set();
  lastTime: number | undefined;
  videoIdentifier: string;

  constructor(videoIdentifier: string) {
    super();

    this.videoIdentifier = videoIdentifier;
    this.lastTime = 0;
  }

  trackVideoStarted(): void {
    if (this.lastTime) {
      return;
    }

    this.watchedSegments.clear();
    VideoPlayerStartedSegmentEvent.dispatch({ videoIdentifier: this.videoIdentifier });
  }

  trackTimeUpdate(currentTime: number, segmentSeconds: number = 30): void {
    const currentSegment: number = Math.floor(currentTime / segmentSeconds);
    if (
      !this.watchedSegments.has(currentSegment) &&
      currentTime >= currentSegment * segmentSeconds &&
      currentSegment !== 0
    ) {
      this.watchedSegments.add(currentSegment);
      VideoPlayerSegmentWatchedSegmentEvent.dispatch({
        videoIdentifier: this.videoIdentifier,
        currentTime
      });
    }

    this.lastTime = currentTime;
  }

  trackVideoEnded(): void {
    this.watchedSegments.clear();
    this.lastTime = 0;

    VideoPlayerEndedSegmentEvent.dispatch({ videoIdentifier: this.videoIdentifier });
  }
}
